<template>
  <div class="modal error-modal">
    <div class="overlay" @click="$parent.closeErrorModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeErrorModal"
              src="./../img/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title dark">ERROR</div>
                <div class="error-message desc dark">
                  {{ $parent.errorModalMessage }}
                </div>
                <button class="button" @click="$parent.closeErrorModal">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorModal",
};
</script>
